module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0126-myakusyoku/myakusyoku.component.css
// module id = ./src/app/a0126-myakusyoku/myakusyoku.component.css
// module chunks = main